import { motion } from "framer-motion";

const CAPITULOS = [
  {
    numero: "01",
    titulo: "O Refúgio",
    texto:
      "No alto das montanhas do Alto Caxixe, entre o verde da mata e o espelho d'água da lagoa, o Laguna Alto Viçosa é um convite a desacelerar e respirar fundo.",
  },
  {
    numero: "02",
    titulo: "Os Chalés",
    texto:
      "Doze chalés batizados com cidades italianas — de Toscana a Napoli — cada um com decoração única, lareira, hidromassagem e café da manhã servido no chalé.",
  },
  {
    numero: "03",
    titulo: "A Experiência",
    texto:
      "Decoração romântica sob medida, espumante ao pôr do sol, piscina privativa nos super luxo e até carregamento para carro elétrico. Cada detalhe, pensado.",
  },
];

export default function Manifesto() {
  return (
    <section id="experiencia" className="px-6 py-20 md:px-12 md:py-32 lg:px-24" data-testid="manifesto-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8C5A40]">O manifesto</p>
        <h2 className="mt-4 max-w-3xl text-3xl font-normal leading-[1.2] tracking-tight md:text-5xl">
          Um refúgio aconchegante e natural, em três capítulos.
        </h2>
      </motion.div>
      <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-8 lg:gap-12">
        {CAPITULOS.map((c, i) => (
          <motion.div
            key={c.numero}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.15 }}
            className="border-t-2 border-[#1C3026] pt-6"
          >
            <span className="text-5xl font-bold text-[#8C5A40]/30">{c.numero}</span>
            <h3 className="mt-4 text-2xl font-bold md:text-3xl">{c.titulo}</h3>
            <p className="mt-4 text-base leading-relaxed text-[#5B7065]">{c.texto}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
